/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Monatsfreibetrag1Inputs */



/**

* @param {_Field_Monatsfreibetrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_monatsfreibetrag1 = /** @type {((inputs?: _Field_Monatsfreibetrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Monatsfreibetrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Monatsfreibetrag")
});
export { _field_monatsfreibetrag1 as "_field_monatsFreibetrag" }